import { Link, useLocation } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MailCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function VerifyEmailPage() {
  const { t } = useTranslation("auth");
  const location = useLocation();
  const email = (location.state as { email?: string })?.email;

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 px-4">
      <Card className="w-full max-w-md text-center shadow-card">
        <CardHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-xl bg-green-100">
            <MailCheck className="h-6 w-6 text-green-600" />
          </div>
          <CardTitle className="text-2xl">{t("verifyEmail.title")}</CardTitle>
          <CardDescription>
            {t("verifyEmail.description")}
            {email && (
              <>
                {" "}
                {t("verifyEmail.descriptionTo")}{" "}
                <span className="font-medium text-foreground">{email}</span>
              </>
            )}
            .
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-muted-foreground">
          <p>{t("verifyEmail.clickLinkInstruction")}</p>
          <p>{t("verifyEmail.checkSpam")}</p>
        </CardContent>
        <CardFooter className="justify-center">
          <Button variant="outline" asChild>
            <Link to="/login">{t("verifyEmail.backToLogin")}</Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
